import { z } from 'zod';

import { FormField, FormValues } from './types';

export const formValidationSchema = z.object({
  [FormField.reason]: z.string().nonempty('Should enter a reason'),
}) satisfies z.ZodType<FormValues>;
